
export const nav = {
  services: "Nos Services",
  process: "Processus",
  universities: "Universités",
  testimonials: "Témoignages",
  faq: "FAQ",
  contact: "Contactez-nous"
};

export const hero = {
  title: "Réalisez Votre Rêve d'Étudier aux États-Unis",
  subtitle: "Nous accompagnons les étudiants d'Afrique francophone dans toutes les étapes de leur parcours académique aux États-Unis. De l'admission à l'installation, nous sommes à vos côtés pour garantir votre succès.",
  ctaStart: "Commencer Maintenant",
  ctaDiscover: "Découvrir Nos Services",
  stats: {
    students: "Étudiants Accompagnés",
    success: "Taux de Réussite",
    universities: "Universités Partenaires"
  }
};

export const services = {
  title: "Nos Services Complets",
  subtitle: "Un accompagnement personnalisé à chaque étape de votre parcours pour garantir votre succès académique aux États-Unis",
  items: [
    {
      title: "Assistance aux Admissions",
      description: "Nous vous aidons à préparer un dossier d'admission complet et compétitif pour les universités américaines. Rédaction de lettres de motivation, CV académique, et conseils personnalisés pour maximiser vos chances d'acceptation."
    },
    {
      title: "Obtention du Visa Étudiant",
      description: "Accompagnement complet pour l'obtention de votre visa F-1. Préparation aux entretiens consulaires, vérification des documents requis, et coaching pour réussir votre entretien à l'ambassade des États-Unis."
    },
    {
      title: "Bourses et Financement",
      description: "Recherche et candidature aux bourses d'études disponibles pour les étudiants internationaux. Nous vous guidons vers les meilleures opportunités de financement et d'aide financière adaptées à votre profil académique."
    },
    {
      title: "Logement et Installation",
      description: "Aide à la recherche de logement sur le campus ou hors campus. Nous vous accompagnons dans vos démarches administratives et vous fournissons toutes les informations nécessaires pour une installation réussie aux États-Unis."
    },
    {
      title: "Tests de Langue",
      description: "Préparation aux tests TOEFL, IELTS et autres examens de langue anglaise requis. Cours de préparation, tests blancs, et stratégies pour obtenir les scores nécessaires à votre admission universitaire."
    },
    {
      title: "Suivi Post-Arrivée",
      description: "Support continu après votre arrivée aux États-Unis. Assistance pour l'ouverture de compte bancaire, obtention du numéro de sécurité sociale, orientation sur le campus, et intégration dans la vie étudiante américaine."
    }
  ]
};

export const process = {
  title: "Notre Processus en 6 Étapes",
  subtitle: "Un accompagnement structuré et éprouvé pour transformer votre rêve d'étudier aux États-Unis en réalité",
  steps: [
    {
      title: "Consultation Initiale",
      description: "Évaluation de votre profil académique, de vos objectifs d'études et de vos préférences universitaires. Nous établissons ensemble un plan personnalisé pour votre parcours aux États-Unis."
    },
    {
      title: "Sélection des Universités",
      description: "Identification des universités américaines correspondant à votre profil, vos aspirations et votre budget. Nous vous aidons à choisir les meilleures options pour maximiser vos chances de réussite."
    },
    {
      title: "Préparation du Dossier",
      description: "Constitution complète de votre dossier d'admission avec tous les documents requis. Rédaction et révision de vos essais, lettres de motivation et recommandations académiques."
    },
    {
      title: "Soumission des Candidatures",
      description: "Envoi de vos candidatures aux universités sélectionnées dans les délais impartis. Suivi rigoureux de l'avancement de chaque candidature et communication avec les bureaux d'admission."
    },
    {
      title: "Obtention du Visa",
      description: "Préparation complète pour votre demande de visa F-1. Coaching pour l'entretien consulaire, vérification des documents et accompagnement jusqu'à l'obtention de votre visa étudiant."
    },
    {
      title: "Préparation au Départ",
      description: "Organisation de votre voyage, recherche de logement, orientation pré-départ et toutes les informations pratiques pour votre installation réussie aux États-Unis."
    }
  ]
};

export const universities = {
  title: "Nos Universités Partenaires",
  subtitle: "Accédez aux meilleures institutions académiques américaines grâce à notre réseau de partenariats établis",
  learnMore: "En Savoir Plus"
};

export const testimonials = {
  title: "Témoignages de Nos Étudiants",
  subtitle: "Découvrez les histoires de réussite de nos étudiants qui ont réalisé leur rêve américain avec notre accompagnement"
};

export const faq = {
  title: "Questions Fréquentes",
  subtitle: "Trouvez les réponses aux questions les plus courantes sur les études aux États-Unis",
  items: [
    {
      question: "Quels sont les critères d'admission pour les universités américaines ?",
      answer: "Les critères varient selon les universités, mais incluent généralement : un bon dossier académique (notes et diplômes), des scores aux tests standardisés (TOEFL/IELTS pour l'anglais, SAT/ACT pour le premier cycle, GRE/GMAT pour les cycles supérieurs), des lettres de recommandation, un essai personnel convaincant, et parfois une expérience professionnelle ou des activités extrascolaires. Nous vous aidons à préparer un dossier complet qui répond à tous ces critères."
    },
    {
      question: "Combien de temps prend le processus d'admission ?",
      answer: "Le processus complet prend généralement entre 6 et 12 mois. Il est recommandé de commencer au moins un an avant la date de rentrée souhaitée. Cela inclut la préparation des tests de langue, la constitution du dossier, la soumission des candidatures, l'attente des réponses, et les démarches de visa. Nous vous accompagnons tout au long de ce processus pour respecter tous les délais importants."
    },
    {
      question: "Quelles sont les options de financement disponibles ?",
      answer: "Plusieurs options existent : bourses d'excellence offertes par les universités, bourses gouvernementales (Fulbright, etc.), aides financières basées sur les besoins, assistanats d'enseignement ou de recherche pour les cycles supérieurs, prêts étudiants internationaux, et programmes de travail sur campus. Nous vous aidons à identifier et postuler aux meilleures opportunités de financement adaptées à votre profil."
    },
    {
      question: "Comment obtenir le visa étudiant F-1 ?",
      answer: "Après avoir été accepté par une université américaine, vous recevrez un formulaire I-20. Vous devrez ensuite : payer les frais SEVIS, remplir le formulaire DS-160, prendre rendez-vous à l'ambassade, préparer les documents requis (passeport, I-20, preuve de financement, etc.), et passer l'entretien consulaire. Nous vous préparons minutieusement pour chaque étape et vous coachons pour l'entretien."
    },
    {
      question: "Quel est le coût des études aux États-Unis ?",
      answer: "Les frais de scolarité varient considérablement : de 20 000 à 60 000 dollars par an selon l'université et le programme. Il faut également prévoir les frais de subsistance (logement, nourriture, transport) estimés entre 10 000 et 20 000 dollars par an. Les universités publiques sont généralement moins chères que les privées. Nous vous aidons à trouver des options abordables et des sources de financement."
    },
    {
      question: "Puis-je travailler pendant mes études ?",
      answer: "Oui, avec un visa F-1, vous pouvez travailler sur le campus jusqu'à 20 heures par semaine pendant les cours et à temps plein pendant les vacances. Après la première année, vous pouvez demander une autorisation CPT (Curricular Practical Training) pour des stages liés à vos études. Après l'obtention du diplôme, l'OPT (Optional Practical Training) permet de travailler jusqu'à 12 mois (36 mois pour les diplômes STEM)."
    },
    {
      question: "Quels documents sont nécessaires pour la candidature ?",
      answer: "Les documents requis incluent : relevés de notes officiels traduits en anglais, diplômes obtenus, scores aux tests de langue (TOEFL/IELTS), scores SAT/ACT ou GRE/GMAT selon le niveau, lettres de recommandation (2-3), essai personnel ou lettre de motivation, CV académique, preuve de financement, copie du passeport, et parfois un portfolio pour certains programmes. Nous vous guidons dans la préparation de chaque document."
    },
    {
      question: "Offrez-vous un suivi après l'arrivée aux États-Unis ?",
      answer: "Absolument ! Notre accompagnement ne s'arrête pas à votre départ. Nous continuons à vous soutenir après votre arrivée : aide à l'installation, orientation sur le campus, conseils pour l'ouverture de compte bancaire, obtention du numéro de sécurité sociale, adaptation à la vie étudiante américaine, et assistance pour toute question administrative. Nous restons disponibles tout au long de vos études."
    }
  ]
};

export const cta = {
  title: "Prêt à Commencer Votre Aventure Américaine ?",
  subtitle: "Contactez-nous dès aujourd'hui pour une consultation gratuite et découvrez comment nous pouvons vous aider à réaliser votre rêve d'étudier aux États-Unis",
  form: {
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    country: "Pays d'origine",
    studyLevel: "Niveau d'études souhaité",
    message: "Message",
    selectLevel: "Sélectionnez un niveau",
    bachelor: "Licence (Bachelor)",
    master: "Master",
    phd: "Doctorat (PhD)",
    other: "Autre",
    submit: "Envoyer Ma Demande",
    required: "*",
    maxChars: "Maximum 500 caractères",
    placeholders: {
      firstName: "Votre prénom",
      lastName: "Votre nom",
      email: "votre.email@exemple.com",
      phone: "+221 XX XXX XX XX",
      country: "Ex: Sénégal, Côte d'Ivoire...",
      message: "Parlez-nous de votre projet d'études aux États-Unis... (500 caractères maximum)"
    },
    alerts: {
      maxLength: "Le message ne peut pas dépasser 500 caractères.",
      success: "Votre demande a été envoyée avec succès ! Nous vous contactons bientôt.",
      error: "Une erreur s'est produite. Veuillez réessayer."
    }
  }
};

export const footer = {
  description: "Votre partenaire de confiance pour réaliser votre rêve d'étudier aux États-Unis. Accompagnement personnalisé de l'admission à l'installation.",
  servicesTitle: "Services",
  quickLinksTitle: "Liens Rapides",
  contactTitle: "Contact",
  services: {
    admissions: "Assistance aux Admissions",
    visa: "Obtention du Visa",
    scholarships: "Bourses et Financement",
    housing: "Logement et Installation",
    language: "Tests de Langue"
  },
  links: {
    process: "Notre Processus",
    universities: "Universités Partenaires",
    testimonials: "Témoignages",
    faq: "FAQ",
    contact: "Contact"
  },
  privacy: "Politique de Confidentialité",
  terms: "Conditions d'Utilisation",
  poweredBy: "Powered by Readdy",
  rights: "Tous droits réservés."
};

export default {
  nav,
  hero,
  services,
  process,
  universities,
  testimonials,
  faq,
  cta,
  footer
};
